import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Avatar,
  Badge,
  IconButton,
  Popover,
  Stack,
  Typography
} from "@mui/material";
import { IMAGE_URL } from "config";
import { isEqual, isNil } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDenominationStore } from "../store";

export function DenominationThumbnail({
  id,
  image,
  name,
  denomination,
  ...props
}) {
  const selectedDenomination = useDenominationStore(
    state => state.selectedDenomination
  );
  const selectDenomination = useDenominationStore(
    state => state.selectDenomination
  );
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Stack
      alignItems="center"
      spacing={1.5}
      {...props}
      sx={{
        overflow: "hidden",
        cursor: "pointer"
      }}
    >
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        badgeContent={
          <IconButton
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "black"
            }}
            onClick={e => {
              e.stopPropagation();
              handleClick(e);
            }}
          >
            <MoreVertIcon />
          </IconButton>
        }
      >
        <Avatar
          sx={{
            width: {
              xs: 60,
              sm: 90,
              lg: 110
            },
            height: {
              xs: 60,
              sm: 90,
              lg: 110
            },
            border: `${
              !isNil(selectedDenomination) &&
              isEqual(id, selectedDenomination.id)
                ? "4px solid"
                : "2px solid transparent"
            }`,
            borderColor: theme => theme.palette.primary.main,
            boxShadow: theme => `0 4px 12px ${theme.palette.action.hover}`
          }}
          src={`${IMAGE_URL}/${image}`}
          alt={name}
        />
      </Badge>
      <Typography
        variant="body2"
        sx={{
          textAlign: "center",
          fontWeight: `${
            !isNil(selectedDenomination) && isEqual(id, selectedDenomination.id)
              ? 600
              : 500
          }`,
          color: `${
            !isNil(selectedDenomination) && isEqual(id, selectedDenomination.id)
              ? "primary.main"
              : "text.primary"
          }`,
          maxWidth: "120px",
          lineHeight: 1.3,
          wordWrap: "break-word",
          hyphens: "auto",
          transition: "color 0.2s ease-in-out"
        }}
      >
        {name}
      </Typography>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <Typography
          onClick={() => {
            selectDenomination(denomination);
            navigate(`/denominations/${id}`);
          }}
          sx={{
            py: 1,
            px: 2,
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#EEEEEE"
            }
          }}
        >
          {t("denominations.createDenomination.denominationProfile")}
        </Typography>
      </Popover>
    </Stack>
  );
}
